import React from 'react';
import ReactModal from 'react-modal';
import './ToastModal.scss';

export default ({
    message,
    isOpen,
    emoji
  }) => {
    return (
      <ReactModal
        parentSelector={() => document.body}
        closeTimeoutMS={500}
        bodyOpenClassName='react-toast-modal-body--open'
        className={`react-toast-modal ${isOpen ? 'show' : ''}`}
        overlayClassName='react-toast-modal-overlay'
        ariaHideApp={false} {...{isOpen}}>
        <div className="react-success-modal-inner">
          {emoji ? <div className="emoji">
            <span role='img' aria-label='thumbs up emoji'>
            { emoji }
            </span>
          </div> : null}
          <div className={`message ${emoji ? 'with-emoji' : ''}`}>{ message }</div>
        </div>
      </ReactModal>
    );
};
